export function resolveCountApplyWriteDelta(
  delta: number,
  liveStockQty: number | null | undefined,
): number | null {
  if (liveStockQty === null) {
    return null;
  }

  return Math.max(delta, -(liveStockQty ?? 0));
}
